var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "manage-overlay" },
    [
      _c(
        "div",
        { staticClass: "manage-bar" },
        [
          _c("span", { staticClass: "manage-title" }, [_vm._v("订单管理")]),
          _c(
            "a-button",
            {
              attrs: { size: "small" },
              on: {
                click: function ($event) {
                  return _vm.$emit("close")
                },
              },
            },
            [_vm._v("返回桌面")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "manage-wrap" },
        [
          _c(
            "div",
            { staticClass: "manage-filters" },
            [
              _c("span", { staticClass: "f-label" }, [_vm._v("状态")]),
              _c(
                "a-select",
                {
                  staticStyle: { width: "110px" },
                  on: { change: _vm.reload },
                  model: {
                    value: _vm.queryStatus,
                    callback: function ($$v) {
                      _vm.queryStatus = $$v
                    },
                    expression: "queryStatus",
                  },
                },
                [
                  _c("a-select-option", { attrs: { value: "" } }, [
                    _vm._v("全部"),
                  ]),
                  _c("a-select-option", { attrs: { value: "pending" } }, [
                    _vm._v("开台中"),
                  ]),
                  _c("a-select-option", { attrs: { value: "ordered" } }, [
                    _vm._v("已下单"),
                  ]),
                  _c("a-select-option", { attrs: { value: "parked" } }, [
                    _vm._v("挂单中"),
                  ]),
                  _c("a-select-option", { attrs: { value: "settled" } }, [
                    _vm._v("已结算"),
                  ]),
                  _c("a-select-option", { attrs: { value: "cancelled" } }, [
                    _vm._v("已取消"),
                  ]),
                  _c("a-select-option", { attrs: { value: "refund" } }, [
                    _vm._v("已退款"),
                  ]),
                ],
                1
              ),
              _c("span", { staticClass: "f-label" }, [_vm._v("类型")]),
              _c(
                "a-select",
                {
                  staticStyle: { width: "90px" },
                  on: { change: _vm.reload },
                  model: {
                    value: _vm.queryOrderType,
                    callback: function ($$v) {
                      _vm.queryOrderType = $$v
                    },
                    expression: "queryOrderType",
                  },
                },
                [
                  _c("a-select-option", { attrs: { value: "" } }, [
                    _vm._v("全部"),
                  ]),
                  _c("a-select-option", { attrs: { value: "dine_in" } }, [
                    _vm._v("堂食"),
                  ]),
                  _c("a-select-option", { attrs: { value: "takeout" } }, [
                    _vm._v("外带"),
                  ]),
                ],
                1
              ),
              _c("span", { staticClass: "f-label" }, [_vm._v("日期")]),
              _c("a-range-picker", { on: { change: _vm.onDateChange } }),
              _c(
                "a-button",
                {
                  attrs: {
                    type: "primary",
                    icon: "search",
                    loading: _vm.loading,
                  },
                  on: { click: _vm.reload },
                },
                [_vm._v("查询")]
              ),
            ],
            1
          ),
          _c("a-table", {
            attrs: {
              columns: _vm.columns,
              "data-source": _vm.rows,
              loading: _vm.loading,
              rowKey: "id",
              size: "middle",
              pagination: _vm.pagination,
            },
            on: { change: _vm.handleTableChange },
            scopedSlots: _vm._u([
              {
                key: "type",
                fn: function (text) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(text === "dine_in" ? "堂食" : "外带") +
                        "\n      "
                    ),
                  ]
                },
              },
              {
                key: "status",
                fn: function (text) {
                  return [
                    _c("a-tag", { attrs: { color: _vm.statusColor(text) } }, [
                      _vm._v(_vm._s(_vm.statusText(text))),
                    ]),
                  ]
                },
              },
              {
                key: "action",
                fn: function (text, record) {
                  return [
                    _c(
                      "a-button",
                      {
                        attrs: { size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.showDetail(record)
                          },
                        },
                      },
                      [_vm._v("详情")]
                    ),
                    _c(
                      "a-button",
                      {
                        staticClass: "act-btn",
                        attrs: { size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.showPrint(record)
                          },
                        },
                      },
                      [_vm._v("厨打")]
                    ),
                    _vm.canRefund && record.status === "settled"
                      ? _c(
                          "a-popconfirm",
                          {
                            attrs: { title: "确认整单退款？" },
                            on: {
                              confirm: function ($event) {
                                return _vm.handleRefund(record)
                              },
                            },
                          },
                          [
                            _c(
                              "a-button",
                              {
                                staticClass: "act-btn",
                                attrs: { size: "small", type: "danger" },
                              },
                              [_vm._v("退款")]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: {
            visible: _vm.detailVisible,
            title: "订单详情",
            footer: null,
            width: "720px",
          },
          on: {
            cancel: function ($event) {
              _vm.detailVisible = false
            },
          },
        },
        [
          _vm.detailData
            ? _c("div", { staticClass: "detail-grid" }, [
                _c("div", { staticClass: "d-item" }, [
                  _c("span", { staticClass: "d-k" }, [_vm._v("订单号")]),
                  _vm._v(_vm._s(_vm.detailData.order_no)),
                ]),
                _c("div", { staticClass: "d-item" }, [
                  _c("span", { staticClass: "d-k" }, [_vm._v("状态")]),
                  _vm._v(_vm._s(_vm.statusText(_vm.detailData.status))),
                ]),
                _c("div", { staticClass: "d-item" }, [
                  _c("span", { staticClass: "d-k" }, [_vm._v("类型")]),
                  _vm._v(
                    _vm._s(
                      _vm.detailData.order_type === "dine_in" ? "堂食" : "外带"
                    )
                  ),
                ]),
                _c("div", { staticClass: "d-item" }, [
                  _c("span", { staticClass: "d-k" }, [_vm._v("桌台")]),
                  _vm._v(_vm._s(_vm.detailData.tableName || "-")),
                ]),
                _c("div", { staticClass: "d-item" }, [
                  _c("span", { staticClass: "d-k" }, [_vm._v("会员")]),
                  _vm._v(_vm._s(_vm.detailData.memberName || "-")),
                ]),
                _c("div", { staticClass: "d-item" }, [
                  _c("span", { staticClass: "d-k" }, [_vm._v("人数")]),
                  _vm._v(_vm._s(_vm.detailData.person_count || "-")),
                ]),
                _c("div", { staticClass: "d-item" }, [
                  _c("span", { staticClass: "d-k" }, [_vm._v("合计")]),
                  _vm._v("¥" + _vm._s(_vm.fmt(_vm.detailData.total_amount))),
                ]),
                _c("div", { staticClass: "d-item" }, [
                  _c("span", { staticClass: "d-k" }, [_vm._v("优惠")]),
                  _vm._v("¥" + _vm._s(_vm.fmt(_vm.detailData.discount_amount))),
                ]),
                _c("div", { staticClass: "d-item" }, [
                  _c("span", { staticClass: "d-k" }, [_vm._v("抹零")]),
                  _vm._v("¥" + _vm._s(_vm.fmt(_vm.detailData.erase_amount))),
                ]),
                _c("div", { staticClass: "d-item" }, [
                  _c("span", { staticClass: "d-k" }, [_vm._v("实付")]),
                  _vm._v("¥" + _vm._s(_vm.fmt(_vm.detailData.pay_amount))),
                ]),
                _c("div", { staticClass: "d-item" }, [
                  _c("span", { staticClass: "d-k" }, [_vm._v("支付")]),
                  _vm._v(_vm._s(_vm.payText(_vm.detailData.pay_type))),
                ]),
                _c("div", { staticClass: "d-item" }, [
                  _c("span", { staticClass: "d-k" }, [_vm._v("收银员")]),
                  _vm._v(_vm._s(_vm.detailData.creatorName || "-")),
                ]),
                _c("div", { staticClass: "d-item" }, [
                  _c("span", { staticClass: "d-k" }, [_vm._v("下单时间")]),
                  _vm._v(_vm._s(_vm.detailData.create_time)),
                ]),
                _c("div", { staticClass: "d-item" }, [
                  _c("span", { staticClass: "d-k" }, [_vm._v("结算时间")]),
                  _vm._v(_vm._s(_vm.detailData.settle_time || "-")),
                ]),
              ])
            : _vm._e(),
          _vm.detailData
            ? _c("a-table", {
                attrs: {
                  columns: _vm.itemColumns,
                  "data-source": _vm.detailData.items || [],
                  rowKey: "id",
                  size: "small",
                  pagination: false,
                  scroll: { y: 260 },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: {
            visible: _vm.printVisible,
            title: "厨打 / 结账单数据",
            footer: null,
            width: "560px",
          },
          on: {
            cancel: function ($event) {
              _vm.printVisible = false
            },
          },
        },
        [
          _c("pre", { staticClass: "print-pre" }, [
            _vm._v(_vm._s(_vm.printText)),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }